// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"b3f2318f","368":"95c444e0","488":"1c6ee080","664":"261e64b0"}[chunkId] + ".chunk.js";
};